import { render, staticRenderFns } from "./ChatPalette.vue?vue&type=template&id=77075206&lang=pug&"
import script from "./ChatPalette.vue?vue&type=script&lang=js&"
export * from "./ChatPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPalette.vue"
export default component.exports